import { crudPage } from '../../components/crud-page.js';
import { Categories } from '../../api/resources.js';

export default async function CategoriesPage(outlet) {
  await crudPage(outlet, {
    title: 'Categorias',
    api: Categories,
    columns: [
      { key: 'name', label: 'Nombre' },
      { key: 'code', label: 'Codigo' },
      { key: 'description', label: 'Descripcion', render: (r) => r.description || '—' },
    ],
    formFields: (item) => [
      { name: 'name', label: 'Nombre', value: item.name, required: true },
      { name: 'code', label: 'Codigo (mayusculas)', value: item.code, required: true, pattern: '[A-Z0-9_-]+' },
      { name: 'description', label: 'Descripcion', value: item.description, type: 'textarea', full: true },
    ],
    transformBeforeSave: (data) => ({ ...data, code: data.code?.toUpperCase() }),
  });
}
